'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'guitar-electric';
var width = 512;
var height = 512;
var aliases = [127928];
var unicode = 'f8be';
var svgPathData = 'M352 114.7l0-33.6c0-10.7 5.3-20.7 14.2-26.6L435.9 8.1C443.8 2.8 453.1 0 462.5 0L464 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L461.3 96 289 268.3c20.3 12 37.3 9.4 48.3 4.7 8.5-3.6 19.3-3.6 25.8 3s6.5 17.3 0 23.8l-21.6 21.8c-8.5 8.6-19.3 13.6-30.1 18.7-11 5.1-22 10.2-30.8 19.2-24.7 25-39.7 65.4-47.2 90.6-4.3 14.6-11.5 28.4-22.2 39.1-30 30.4-78.7 30.4-108.8 0L22.5 408.5c-30-30.4-30-79.6 0-110 10.7-10.8 24.3-18.1 38.7-22.4 24.9-7.6 64.9-22.7 89.6-47.7 9.3-9.4 14.9-21.1 20.5-32.7l0 0c5.6-11.6 11.1-23.1 20.3-32.4l29.9-30.2c6.5-6.6 17.1-6.6 23.6 0s6.6 17.4 1.7 25.3c-8.7 14.4-17.8 38.7-3.2 64.7L352 114.7zM201 263c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-48-48zm-64 64c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-48-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGuitarElectric = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;